<template>
    <div>
        <hero-bar :has-right-visible="true" menu-icon="desktop-mac">
            {{ $lang.Menus.Users }}

            <p v-if="backBtnActive == true" class="control" slot="right" style="margin-right: 16px">
                <b-button class="button is-gray" @click="previous">{{ $lang.Menus.BackBtn }}</b-button>
            </p>
        </hero-bar>

        <div class="section is-main-section table-page">
            <!--
                Ten columns. The design draws KVKK İzni as well, from screenshots taken
                before e6e2f36 removed it: Members has no such column and the grid used to
                invent true for every row. It stays out. İş Telefonu is out too, at EAE's
                request: the forms no longer collect it, and it stood beside Telefon.
            -->
            <b-table v-if="$store.state.memberId != 'TestMember' && $store.state.isAdmin == 1"
                     class="data-table is-sticky-lead"
                     style="--table-min: 1474px"
                     :data="members"
                     :loading="isLoading"
                     :mobile-sort-placeholder="$lang.MyProjects.SortBy"
                     :paginated="isPaginated"
                     :per-page="perPage"
                     hoverable>
                <b-table-column field="FullName" :label="$lang.AdminExcel.UserName" v-slot="props" cell-class="cell-strong m-title">
                    {{ props.row.Name }} {{ props.row.SurName }}
                </b-table-column>
                <b-table-column field="Email" :label="$lang.Member.Email" v-slot="props" cell-class="m-sub">
                    {{ props.row.Email }}
                </b-table-column>
                <b-table-column field="Title" :label="$lang.Member.Title" v-slot="props" cell-class="m-full">
                    {{ props.row.Title }}
                </b-table-column>
                <b-table-column field="Country" :label="$lang.Member.Country" v-slot="props" searchable>
                    {{ props.row.Country }}
                </b-table-column>
                <b-table-column field="City" :label="$lang.Member.City" v-slot="props" searchable>
                    {{ props.row.City }}
                </b-table-column>
                <b-table-column field="Town" :label="$lang.Member.Town" v-slot="props" searchable>
                    {{ props.row.Town }}
                </b-table-column>
                <b-table-column field="Phone" :label="$lang.Member.Phone" v-slot="props" width="166" numeric>
                    {{ props.row.Phone }}
                </b-table-column>
                <b-table-column field="CommLanguage" :label="$lang.Member.CommLanguage" v-slot="props" width="126">
                    {{ props.row.CommLanguage }}
                </b-table-column>
                <!-- A mark rather than a raw true / false, as in the design; the word is kept for screen readers. -->
                <b-table-column field="AllowComm" :label="$lang.Member.AllowComm" v-slot="props" width="132">
                    <span class="consent-mark"
                          :class="props.row.AllowComm ? 'is-yes' : 'is-no'"
                          :title="props.row.AllowComm ? $lang.AdminExcel.Yes : $lang.AdminExcel.No">
                        <span class="mdi" :class="props.row.AllowComm ? 'mdi-check-circle' : 'mdi-close-circle'" aria-hidden="true"></span>
                        <span class="is-sr-only">{{ props.row.AllowComm ? $lang.AdminExcel.Yes : $lang.AdminExcel.No }}</span>
                    </span>
                </b-table-column>
                <b-table-column field="CreateDate" :label="$lang.AdminExcel.CreateDate" v-slot="props" width="166" numeric sortable>
                    {{ formatDate(props.row.CreateDate) }}
                </b-table-column>

                <template #empty>
                    <!-- Rows loaded but none shown: the column search filtered them all out. -->
                    <p v-if="!isLoading" class="table-empty">{{ members.length ? $lang.AdminExcel.NoMatch : $lang.AdminExcel.EmptyUsers }}</p>
                </template>

                <template #bottom-left>
                    <span class="table-count">{{ members.length }} {{ $lang.AdminExcel.UserCountSuffix }}</span>
                    <b-button type="is-link" icon-right="download" @click="downloadMembers()">{{ $lang.AdminExcel.Download }}</b-button>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';

    export default {
        name: 'Users',
        data() {
            return {
                isActive: true,
                isLoading: false,
                firstDate: new Date(),
                secondDate: new Date(),
                showWeekNumber: false,
                enableSeconds: false,
                hourFormat: undefined, // Browser locale
                locale: undefined, // Browser locale
                firstDayOfWeek: undefined, // 0 - Sunday
                isPaginated: true,
                perPage: 10,
                members: [],
                backBtnActive: false
            }
        },
        mounted() {
            if (this.$store.state.previousRoute == 'projectInfos' || this.$store.state.previousRoute == 'panelInfos' || this.$store.state.previousRoute == 'envConditions' ||
                this.$store.state.previousRoute == 'calc_Busbar' || this.$store.state.previousRoute == 'calc_InputCircuit' || this.$store.state.previousRoute == 'calc_OutputCircuit' ||
                this.$store.state.previousRoute == 'calc_Manuel' || this.$store.state.previousRoute == 'calc_Summary' || this.$store.state.previousRoute == 'results' ||
                this.$store.state.previousRoute == 'reportPdfPage' || this.$store.state.previousRoute == 'calculation') {
                this.backBtnActive = true;
            } else {
                this.backBtnActive = false;
            }
            this.getMembersTable();

            this.$store.state.isFooterFixed = true;
        },
        destroyed() {
            this.$store.state.isFooterFixed = false;
        },
        methods: {
            getMembersTable() {
                this.isLoading = true;
                this.members = [];
                api.panels.getMembersList().then((res) => {
                    this.isLoading = false;
                    if (!res || res.isError) {
                        console.log("error ");
                    } else {
                        res.data.forEach((e) => {
                            this.members.push(e);
                        });
                    }
                });
            },
            clearDateTime_1() {
                this.firstDate = null
            },
            clearDateTime_2() {
                this.secondDate = null
            },
            formatDate(date) {
                if (date == null) {
                    return '-';
                } else {
                    var yil = date.getFullYear();
                    var ay = ('0' + (date.getMonth() + 1)).slice(-2);
                    var gun = ('0' + date.getDate()).slice(-2);
                    var saat = ('0' + date.getHours()).slice(-2);
                    var dakika = ('0' + date.getMinutes()).slice(-2);

                    var formatliTarih = gun + '-' + ay + '-' + yil + ' ' + saat + ':' + dakika;

                    return formatliTarih;
                }
            },

            columnTdAttrs(row, column) {
                if (row.id === 'Total') {
                    if (column.label === 'ID') {
                        return {
                            colspan: 4,
                            class: 'has-text-weight-bold',
                            style: {
                                'text-align': 'left !important'
                            }
                        }
                    } else if (column.label === 'Gender') {
                        return {
                            class: 'has-text-weight-semibold'
                        }
                    } else {
                        return {
                            style: { display: 'none' }
                        }
                    }
                }
                return null
            },
            previous() {
                router.push('/' + this.$store.state.previousRoute);
            },
            downloadMembers() {
                this.isLoading = true;

                var path = 'GetMembers_Excel?langCode=' + this.$lang.Format.Lang
                api.reportApi.downloadMembers(this.$lang.Menus.Users, path).then((res) => {
                    this.sendEmail();
                    this.isLoading = false;
                });
            },
            sendEmail() {
                var memberId = this.$store.state.memberId;
                api.members.SendUserListDownloadedMail(memberId).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    } else {
                    }
                });
            },
        }
    };
</script>
